import React from "react"
import { InputRounding, InputSize, InputVariant, ThemeColor } from "@punks/core"
import { lightBlack } from "../../../themes/variables"
import CustomTextInput from "../../atoms/CustomTextInput"
import { MdVisibility, MdVisibilityOff } from "react-icons/md"
import CustomButton from "../../atoms/Button"
import classes from "./CustomPasswordInput.module.css"

interface Props {
  id?: string
  color: ThemeColor
  borderColor: ThemeColor
  value?: string
  size: InputSize
  variant?: InputVariant
  onChange?: (value: string) => void
  label?: string
  autoComplete?: string
  fullWidth?: boolean
  required?: boolean
  rounding?: InputRounding
  register: any
  name: string
  error: boolean
  inputFontWeight?: string
  labelFontWeight?: string
  inputFontSize?: string | number
  labelFontSize?: string | number
  className?: string
  onEnterKey?: () => void
}

const CustomPasswordInput = ({
  id,
  value,
  color,
  borderColor,
  size,
  variant,
  onChange,
  label,
  autoComplete,
  fullWidth,
  required,
  register,
  name,
  error,
  inputFontWeight,
  labelFontWeight,
  rounding,
  className,
  onEnterKey,
  ...rest
}: Props) => {
  const [showPassword, setShowPassword] = React.useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault()
  }

  return (
    <CustomTextInput
      id={id}
      variant={variant}
      required={required}
      fullWidth={fullWidth}
      error={error}
      name={name || "password"}
      inputRef={register}
      type={showPassword ? "text" : "password"}
      value={value}
      autoComplete={autoComplete}
      defaultValue={value}
      label={label}
      onChange={onChange}
      onEnterKey={onEnterKey}
      // classes={{ input: classes.input, notchedOutline: classes.fieldset }}
      // classes={{ input: classes.input }}
      classes={{ endAdornment: classes.endAdornment }}
      endAdornment={
        <CustomButton
          variant="text"
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDownPassword}
          className={classes.toggleVisibility}
          classes={{
            inner: classes.toggleVisibilityInner,
          }}
        >
          {showPassword ? (
            <MdVisibility color={lightBlack} size={24} />
          ) : (
            <MdVisibilityOff color={lightBlack} size={24} />
          )}
        </CustomButton>
      }
      {...rest}
    />
  )
}

CustomPasswordInput.defaultProps = {
  id: "pwd",
  color: lightBlack,
  borderColor: lightBlack,
  size: "small",
  variant: "filled",
}

export default CustomPasswordInput
